import { render, staticRenderFns } from "./Sat.vue?vue&type=template&id=122820a4"
import script from "./Sat.vue?vue&type=script&lang=js"
export * from "./Sat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports